import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../Services/auth.service';

@Component({
  standalone: true,
  selector: 'logout-guard',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ''
})
export class LogoutGuard implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);


  ngOnInit(): void {
    this.authService.logout();

    window.location.href = "/";
  }
}
